/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react';
import { Card, Container, Tab, Tabs } from '@material-ui/core';
import { useStyles } from './useStyles';
import StakeAlert from '../components/StakeAlert';
import { LockedPoolInfoContainer } from '../components/LockedPoolInfoContainer';
import { LockedPoolBalanceInfoContainer } from '../components/LockedPoolBalanceInfoContainer';
import { StakeLockedPoolLength } from '../utils/stakeHelper';

export const LockedPoolView = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(StakeLockedPoolLength.MONTH4);
  const handleTabChange = useCallback((event, value) => {
    setTab(value);
  }, []);

  return (
    <Container className="container">
      <Card className={classes.mainCard}>
        <StakeAlert
          stakeAlertText="Please note that your tokens can't be
        redeemed before the staking window closes. Your token rewards for
        this pool are also staggered. For example, if you stake 1000 CHICKS in
        our 4 month pool, you will receive your 1000 CHICKS after 4 months, and
        then you will receive your token reward after 8 months. If you staked
        the same amount in our 8 month pool, then you will receive your token
        rewards after 16 months. Same principle applies for the 12 month pool.
        All other rewards can be claimed when the initially staked tokens are
        unlocked."
        />
        <Tabs
          value={tab}
          variant="fullWidth"
          indicatorColor="primary"
          onChange={handleTabChange}
        >
          <Tab
            className={classes.tab}
            label="4 MONTHS"
            value={StakeLockedPoolLength.MONTH4}
          />
          <Tab
            className={classes.tab}
            label="8 MONTHS"
            value={StakeLockedPoolLength.MONTH8}
          />
          <Tab
            className={classes.tab}
            label="12 MONTHS"
            value={StakeLockedPoolLength.MONTH12}
          />
        </Tabs>
        <div className={classes.mainTab}>
          <LockedPoolInfoContainer tab={tab} />
          <LockedPoolBalanceInfoContainer tab={tab} />
        </div>
      </Card>
    </Container>
  );
};
